import { WorkItemController } from "../workItemController";
import {
  WorkItemServiceProvider,
  vsProviderName as WorkItemServiceProviderName,
} from "../";

containerConfig.$inject = ["formlyConfigProvider", WorkItemServiceProviderName];
export function containerConfig(
  formlyConfigProvider: AngularFormly.IFormlyConfig,
  workItemServiceProvider: WorkItemServiceProvider,
) {
  workItemServiceProvider.addWorkItemType({
    name: "Collection",
    formlyFieldType: "container",
  });

  workItemServiceProvider.addWorkItemType({
    name: "Sequence",
    formlyFieldType: "container",
  });

  formlyConfigProvider.setType({
    name: "container",
    template: require("!html-loader!./index.html").default,
    controller: WorkItemController,
  });
}
